export default "__VITE_ASSET__BS5is_38__"